import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

export type WidgetCategory =
  | 'kpi'
  | 'overdue'
  | 'anaf'
  | 'sales'
  | 'cashflow'
  | 'ops'
  | 'ai';

export type WidgetSize = 'S' | 'M' | 'L' | 'XL' | 'Full';

export interface WidgetDefinition {
  id: string;
  title: string;
  description: string;
  category: WidgetCategory;
  /** Dimensiune standardizată — mapată la w,h în SIZE_DIMS */
  size: WidgetSize;
  /** @deprecated — se păstrează temporar pentru componente care încă îl citesc. */
  defaultSpan?: number;
  /** @deprecated — înlocuit de size */
  defaultRow?: number;
  /** Override manual pentru dimensiuni (h, w, minH etc.) când preset-ul size nu se potrivește */
  sizeOverride?: { w?: number; h?: number; minW?: number; maxW?: number; minH?: number; maxH?: number };
  /** Mark as NEW in picker. */
  isNew?: boolean;
  /** Icon shown in widget header + picker. */
  icon?: LucideIcon;
  /** React component rendering the widget body (without card wrapper). */
  Component: () => ReactNode;
}

export interface DashboardLayout {
  /** Ordered list of widget IDs currently visible. */
  visible: string[];
  /** Widget IDs explicitly hidden by user. */
  hidden: string[];
  /** Per-widget overrides (span etc). Future. */
  overrides?: Record<string, { span?: number; row?: number }>;
  /** Versiunea layout-ului — folosită la migrarea default-ului (v2 = setul
   *  „esențial" 2026-07-12). Lipsă = layout salvat înainte de versionare. */
  v?: number;
}

// Etichete pe românește, fără jargon (decizie owner 2026-07-13): publicul e
// non-tehnic (PFA/firme mici) — „KPI", „Overdue", „Insights" nu-i ajută.
export const CATEGORY_LABELS: Record<WidgetCategory, string> = {
  kpi: 'Indicatori financiari',
  overdue: 'Restanțe & risc',
  anaf: 'ANAF & obligații fiscale',
  sales: 'Vânzări & evoluție',
  cashflow: 'Bani & prognoze',
  ops: 'Operațiuni & productivitate',
  ai: 'Sugestii inteligente',
};
